import { connect } from 'react-redux';
import { State } from 'store/types';
import View from './View';

const mapStateToProps = (state: State) => {
  const { appReducer } = state;
  return {
    device: appReducer.client.device,
    region: state.appReducer.region,
  };
};

export default connect(mapStateToProps)(View);
